export const EWALLET_VENDORS = {
  EWALLET_OVO: {
    code: "EWALLET_OVO",
    name: "OVO",
    flowType: "push_to_pay",
    requiresPhone: true,
    hasRedirectUrl: false,
    brandColor: "#4C3494",
    brandHoverColor: "#3a2770",
    description: "Selesaikan pembayaran melalui aplikasi OVO Anda.",
    buttonText: "Bayar dengan OVO",
  },
  EWALLET_SHOPEEPAY: {
    code: "EWALLET_SHOPEEPAY",
    name: "ShopeePay",
    flowType: "redirect",
    requiresPhone: false,
    hasRedirectUrl: true,
    brandColor: "#EE4D2D",
    brandHoverColor: "#d73211",
    description: "Selesaikan pembayaran Anda dengan aman melalui aplikasi atau website ShopeePay.",
    buttonText: "Bayar dengan ShopeePay",
  },
  EWALLET_DANA: {
    code: "EWALLET_DANA",
    name: "Dana",
    flowType: "redirect",
    requiresPhone: false,
    hasRedirectUrl: true,
    brandColor: "#0081CE",
    brandHoverColor: "#006bb3",
    description: "Selesaikan pembayaran Anda dengan aman melalui aplikasi atau website Dana.",
    buttonText: "Bayar dengan Dana",
  },
  EWALLET_GOPAY: {
    code: "EWALLET_GOPAY",
    name: "GoPay",
    flowType: "redirect",
    requiresPhone: false,
    hasRedirectUrl: true,
    brandColor: "#00AED6",
    brandHoverColor: "#0095b8",
    description: "Selesaikan pembayaran Anda dengan aman melalui aplikasi GoPay atau Gojek.",
    buttonText: "Bayar dengan GoPay",
  },
};

export function getVendorConfig(methodCode) {
  return EWALLET_VENDORS[methodCode] || null;
}

export function isEwalletMethod(methodCode) {
  return methodCode in EWALLET_VENDORS;
}
